import { Inbox } from "common/types/common.type";

export const inbox: Inbox[] = [
  {
    id: "38v8ury2e7eleynh2h3",
    name: "John Smith",
    image: "/assets/images/boy1.webp",
    participantId: "6200000",
    lastMessage: "Testing",
    notificationsCount: 5,
    messageStatus: "sent",
    timestamp: "08:21",
    isPinned: true,
    pinnedAt: "2022-05-28 09:30:00",
    updatedAt: ""
  },
  {
    id: "38v8ury2e80leynh9lp",
    name: "Jane Doe",
    image: "/assets/images/boy2.jpeg",
    participantId: "6200000",
    lastMessage: "Hello there!",
    notificationsCount: 2,
    messageStatus: "sent",
    timestamp: "12:15",
    isPinned: true,
    isOnline: true,
    updatedAt: ""
  },
  {
    id: "38v8ury2e8hleynhflu",
    name: "Bob Johnson",
    image: "/assets/images/boy3.jpeg",
    participantId: "6200000",
    lastMessage: "How are you?",
    notificationsCount: 0,
    messageStatus: "read",
    timestamp: "6:47",
    updatedAt: ""
  },
  {
    id: "38v8ury2e8yleynhli9",
    name: "Samantha Lee",
    image: "/assets/images/girl1.jpeg",
    participantId: "6200000",
    lastMessage: "See you tomorrow!",
    messageStatus: "sent",
    timestamp: "09:35",
    updatedAt: ""
  },
  {
    id: "38v8ury2e9cleynhqgh",
    name: "William Chen",
    image: "/assets/images/boy4.jpeg",
    participantId: "6200000",
    lastMessage: "Thanks for your help!",
    messageStatus: "delivered",
    timestamp: "5:22",
    updatedAt: ""
  },
  {
    id: "38v8ury2ectleyniehz",
    name: "Emily Kim",
    image: "/assets/images/girl2.jpeg",
    participantId: "6200000",
    lastMessage: "Are you free tonight?",
    messageStatus: "read",
    timestamp: "4:10",
    isOnline: true,
    updatedAt: ""
  },
  {
    id: "38v8ury2edbleynin0d",
    name: "David Wong",
    image: "/assets/images/boy5.webp",
    participantId: "6200000",
    lastMessage: "Let's meet at the park!",
    messageStatus: "sent",
    timestamp: "13:48",
    updatedAt: ""
  },
  {
    id: "38v8ury2edsleynisii",
    name: "Karen Lee",
    image: "/assets/images/girl.jpeg",
    participantId: "6200000",
    lastMessage: "I'll be there in 10 minutes.",
    messageStatus: "delivered",
    timestamp: "08:56",
    isOnline: true,
    updatedAt: ""
  },
  {
    id: "38v8ury2ee6leynix43",
    name: "Daniel Lee",
    image: "/assets/images/boy6.webp",
    participantId: "6200000",
    lastMessage: "Can you send me the file?",
    messageStatus: "read",
    timestamp: "19:03",
    updatedAt: ""
  },
];
